import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { AuthService } from '@core/authentication/services/auth.service';
import { AuthResponse } from '@core/authentication/model/auth.model';

@Injectable({ providedIn: 'root' })
export class LoginConnector {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  login(user: string, pw: string): Observable<AuthResponse> {
    const url = `${environment.apiService}/auth/login`;

    return this.http.post<AuthResponse>(url, {
      username: user,
      password: pw,
    });
  }

  logout(): Observable<boolean> {
    const url = `${environment.apiService}/auth/logout`;
    const token = this.authService.getAccessToken();
    return this.http.post<boolean>(url, {
      refreshToken: token,
    });
  }
}
